import {Client} from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import {buildSourcesTopic, normalizeRealtimePayload} from './sourcesAdapter';

function getSourcesWsBase() {
    return (process.env.REACT_APP_SOURCES_WS_BASE || 'https://awp.minsky.ai').replace(/\/$/, '');
}

const SOURCES_SOCKJS_TRANSPORTS = ['xhr-streaming', 'xhr-polling'];

function buildSourcesHandshakeUrl(baseUrl, userId) {
    const handshakeUrl = `${baseUrl}/ws`;

    if (!userId) {
        return handshakeUrl;
    }

    const searchParams = new URLSearchParams({userId});
    return `${handshakeUrl}?${searchParams.toString()}`;
}

export function createSourcesRealtimeSubscription({view, userId, onConnect, onMessage, onError, onClose}) {
    const topic = buildSourcesTopic({...view, userId});
    const sourcesWsBase = getSourcesWsBase();
    const handshakeUrl = buildSourcesHandshakeUrl(sourcesWsBase, userId);

    if (!userId) {
        const details = {
            event: 'missing-user-id',
            topic,
            userId: userId || null,
            message: 'Sources realtime subscription requires an authenticated user id.',
        };

        console.error('[SourcesSection] Missing user id for realtime subscription', details);
        onError?.(details);

        return () => {
        };
    }

    const client = new Client({
        webSocketFactory: () => new SockJS(handshakeUrl, null, {
            transports: SOURCES_SOCKJS_TRANSPORTS,
            transportOptions: {
                'xhr-streaming': {headers: {'X-User-Id': userId}},
                'xhr-polling': {headers: {'X-User-Id': userId}},
            },
        }),
        connectHeaders: userId ? {'X-User-Id': userId} : {},
        reconnectDelay: 5000,
        onConnect: () => {

            onConnect?.({topic});

            client.subscribe(topic, (message) => {
                const normalizedPayload = normalizeRealtimePayload(message?.body);

                onMessage?.({
                    topic,
                    userId: userId || null,
                    ...normalizedPayload,
                });
            });
        },
        onStompError: (frame) => {
            const details = {
                event: 'stomp-error',
                topic,
                userId: userId || null,
                message: frame?.headers?.message || frame?.body || 'Unknown STOMP error',
                frame,
            };

            console.error('[SourcesSection] STOMP error', details);
            onError?.(details);
        },
        onWebSocketClose: (event) => {
            const details = {
                event: 'socket-close',
                topic,
                userId: userId || null,
                code: event?.code,
                reason: event?.reason || '',
            };

            onClose?.(details);
        },
        onWebSocketError: (event) => {
            const details = {
                event: 'socket-error',
                topic,
                userId: userId || null,
                eventObject: event,
            };

            console.error('[SourcesSection] WebSocket error', details);
            onError?.(details);
        },
    });

    client.activate();

    return () => {
        client.deactivate();
    };
}


